import { Modal, StackModalProps } from 'almanac-ui/Modal'
import { CopyRight2 } from 'blaze-ui/icons'
import { Button } from 'components/Button'

export interface Props extends StackModalProps {
  onCancel: () => void
  onConfirm: () => void
  onPressOutside: () => void
}

export const DuplicateConfirmModal = ({ onCancel, onConfirm, onPressOutside }: Props) => (
  <Modal.Root onPressOutside={onPressOutside}>
    <Modal.Header title="Are you sure you want to copy this page?" />
    <Modal.Content>New page will be placed after the last page of this design.</Modal.Content>
    <Modal.Footer>
      <Modal.FooterContent slot="left">
        <Button onPress={onCancel} size="xl" variant="tertiary">
          Cancel
        </Button>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Button onPress={onConfirm} size="xl" variant="primary" frontIcon={CopyRight2}>
          Copy page
        </Button>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
